import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZoneComponent } from './zone.component';


@NgModule({
  declarations: [ZoneComponent],
  exports: [
    ZoneComponent
  ],
  imports: [
    CommonModule,
  ],
  providers: []
})
export class ZoneModule { }
